




























































































































import VueOptions from '@utils/VueOptions'
import RequestButton from '@/components/RequestButton'

settings =
  name: "CreateWizard"
  # resources:
  #   eventWizard: 
  #     resourceName: "event_wizard"
  #     slug: "event_wizards/new"
  vue:
    props: ['show', 'eventWizard', 'options', 'context', 'actions', 'page']
    store: ['marketplace']
    components: { RequestButton }
    data: ->
      selectedSubOrg: null

      selectedEventSet: null
      selectedToCreateNewEventSet: true

    computed:
      subOrganizationOptions: -> @options.sub_organizations || []
      eventSetOptions: -> @selectedSubOrg?.event_sets || []

      listingClasses: ->
        data = @marketplace?.listing?.classes
        order = @marketplace.listing?.promoted?.classes
        @hashToElementUIOptions data, order
      listingTypes: ->
        data = @marketplace?.listing?.types
        order = @marketplace.listing?.promoted?.types
        @hashToElementUIOptions data, order
      listingCategories: ->
        data = @marketplace?.listing?.categories
        order = @marketplace.listing?.promoted?.categories
        @hashToElementUIOptions data, order

    methods:
      handleBackClicked: -> @$parent.setPage(@page - 1)
      nextClicked: ->
        if @page is 2
          if  !@eventWizard.name?
            return @showAlert('You must provide the name of your event in order to continue.', 'Validation Error')
          else if not @eventWizard.physical_event and not @eventWizard.live_stream
            return @showAlert('Please indicate wether the attendees will experience the event in person, over a live stream or both', 'In Person and/or Live Stream?')
        if true is @selectedToCreateNewEventSet and @page is 2
          @saveWizard(@page + 1)
        else if @selectedEventSet?.id? and @page is 1
          event_set_id = @selectedEventSet.id
          @actions.createNextEvent(event_set_id)
          # +++ send new start date in the payload
        else
          @$parent.setPage(@page + 1)
      saveWizard: (nextPage) ->
        nextPage ||= @page
        @eventWizard.supplier_sub_organization.id = @selectedSubOrg?.id
        @actions.saveWizard(nextPage)
      closeWizard: -> @$parent.closeWizard()
      saveAndExit: ->
        if !@eventWizard.name?
          return @showAlert('You must provide the name of your event in order to continue.', 'Validation Error')
        else 
          @saveWizard(-1)
      # onSave: (event) -> @navToEdit event
      
      # navToEdit: (event) ->
      #   @$router.push({ name: 'EventEditPage', params: { eventId: event.id }, query: { page: 2 } })

      onlyOneSubOrg: -> 1 is @subOrganizationOptions.length
      moreThanOneSubOrg: -> 1 < @subOrganizationOptions.length
      autoSelectSubOrgWhenOnlyOne: ->
        @selectedSubOrg = @subOrganizationOptions[0] if @onlyOneSubOrg()
      isCreatingFirstEvent: ->
        @isCreatingFirstEventEver() or @isCreatingFirstEventForSelectedSubOrg()
      isCreatingFirstEventEver: ->
        @onlyOneSubOrg() and 0 is @eventSetOptions.length
      isCreatingFirstEventForSelectedSubOrg: ->
        @selectedSubOrg? and 0 is @eventSetOptions.length
      initializeWizard: (composite) ->
        @autoSelectSubOrgWhenOnlyOne()
        if @onlyOneSubOrg() # auto create 1st event
          @selectedEventSet = null
          @selectedToCreateNewEventSet = true
          @$parent.setPage(2)

      # SubOrg selector
      subOrgIsSelected: (org)-> @selectedSubOrg?.id is org?.id
      toggleSelectedSubOrg:(org)->
        @selectedSubOrg = org
        @selectedEventSet = null
        # @selectedToCreateNewEventSet = org? and 0 is org.event_sets.length
        @$parent.setPage(2) # if @isCreatingFirstEventForSelectedSubOrg()

      # EventSet Selector
      eventSetIsSelected: (eventSet)->
        @selectedEventSet? and @selectedEventSet.id is eventSet.id
      toggleSelectedEventSet:(eventSet)->
        @selectedEventSet = eventSet
        # @selectedToCreateNewEventSet = !eventSet?
    watch:
      page: -> document.getElementById('scrollview')?.scrollTo(0,0)

      eventWizard: -> @initializeWizard()

export default VueOptions.vue settings
